module.exports = __webpack_public_path__ + "img/virus.39f4366.svg";